<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
    name: string,
    icon: string,
    menuGroup: boolean
}>();

const menuGroup = ref(props.menuGroup)

</script>
<template>
    <li>
        <a @click="menuGroup = !menuGroup">
            <i class="fas" :class="icon"></i>
            {{ props.name }}
            <i class="fas ml-auto text-xs"
                :class="{ 'fa-chevron-down': menuGroup, 'fa-chevron-right': !menuGroup }"></i>
        </a>
        <ul class="sidebar-sub-menu" v-if="menuGroup">
            <slot />
        </ul>
    </li>
</template>